<template>
	<div class="whatsapp-action-form">
		<!-- Template Selection and Variables Mapping -->
		<whats-app-template-field
			v-model="templateData"
			label="Template WhatsApp"
			placeholder="Seleziona un template WhatsApp"
			prepend-icon="mdi-whatsapp"
			:required="true"
		/>

		<!-- Send to Contacts Switch -->
		<v-switch
			v-model="localAction.send_to_contacts"
			label="Invia ai contatti invece che all'azienda"
			color="primary"
			dense
			inset
			hide-details
			class="mt-2"
			@change="onSendToContactsChange"
		></v-switch>

		<!-- Contact Type Selection -->
		<v-select
			v-if="localAction.send_to_contacts"
			v-model="localAction.contact_type"
			:items="contactTypes"
			item-text="text"
			item-value="value"
			label="Tipo Contatto"
			placeholder="Seleziona uno o più tipi di contatto"
			outlined
			multiple
			chips
			small-chips
			deletable-chips
			dense
			:loading="loadingContactTypes"
			:rules="[v => (v && v.length > 0) || 'Almeno un tipo contatto richiesto']"
			prepend-icon="mdi-account-box"
			class="mt-4"
		></v-select>

		<!-- Fallback Options (only if send_to_contacts is true) -->
		<template v-if="localAction.send_to_contacts">
			<v-checkbox
				v-model="localAction.send_to_company_telephone"
				dense
				hide-details
				class="mt-2"
			>
				<template v-slot:label>
					<div>
						<v-icon small left>mdi-phone</v-icon>
						<span class="text-body-2">Invia a numero Aziendale se non è presente il tipo contatto scelto</span>
					</div>
				</template>
			</v-checkbox>
			<div v-if="localAction.send_to_company_telephone" class="text-caption ml-8 mb-2 text--secondary">
				Se attivo, il messaggio verrà inviato al numero dell'azienda solo quando non sono presenti contatti del tipo selezionato
			</div>
		</template>

		<!-- Always Send to Company -->
		<v-checkbox
			v-model="localAction.send_to_company_telephone_always"
			dense
			hide-details
			class="mt-2"
		>
			<template v-slot:label>
				<div>
					<v-icon small left>mdi-email-multiple</v-icon>
					<span class="text-body-2">Invia sempre a numero Aziendale oltre che ai contatti</span>
				</div>
			</template>
		</v-checkbox>
	</div>
</template>

<script>
	import WhatsAppTemplateField from '@/components/common/WhatsAppTemplateField'

	export default {
		name: 'WhatsAppActionForm',
		components: {
			WhatsAppTemplateField
		},
		props: {
			value: {
				type: Object,
				required: true
			},
			modelType: {
				type: String,
				default: ''
			}
		},

		data() {
			return {
				localAction: {
					template_id: null,
					send_to_contacts: false,
					contact_type_id: [],
					send_to_company_telephone: false,
					send_to_company_telephone_always: false,
					variables_mapping: {},
					...this.value
				},
				contactTypes: [],
				loadingContactTypes: false
			}
		},

		computed: {
			templateData: {
				get() {
					return {
						template_id: this.localAction.template_id,
						variables_mapping: this.localAction.variables_mapping
					}
				},
				set(value) {
					this.localAction.template_id = value.template_id
					this.localAction.variables_mapping = value.variables_mapping
					this.emitUpdate()
				}
			}
		},

		watch: {
			'localAction.send_to_contacts'(val) {
				this.emitUpdate()
			},
			'localAction.contact_type'(val) {
				this.emitUpdate()
			},
			'localAction.send_to_company_telephone'(val) {
				this.emitUpdate()
			},
			'localAction.send_to_company_telephone_always'(val) {
				this.emitUpdate()
			}
		},

		mounted() {
			this.loadContactTypes()
		},

		methods: {
			loadContactTypes() {
				this.loadingContactTypes = true
				this.axios.post('generaltype/', { key: 'contact_type' }).then(response => {
					// La risposta è un array diretto di oggetti {value, text}
					this.contactTypes = response.data.general_type
					this.loadingContactTypes = false
				}).catch(error => {
					console.error('Error loading contact types:', error)
					this.loadingContactTypes = false
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: 'Errore nel caricamento dei tipi di contatto',
						value: true,
						color: 'error'
					})
				})
			},

			onSendToContactsChange(value) {
				if (!value) {
					// Se disattiviamo "invia ai contatti", resettiamo i campi correlati
					this.localAction.contact_type_id = []
					this.localAction.send_to_company_telephone = false
				}
			},

			emitUpdate() {
				this.$emit('input', { ...this.localAction })
			}
		}
	}
</script>

<style scoped>
	.whatsapp-action-form {
		padding: 8px 0
	}
</style>
